<template>
  <div style="max-width: 200px">
    <ViewListFieldValue
      v-if="isListField"
      :contactName="contactName"
      :field="fieldSchema"
      :value="fieldValue"
      @click.native.stop
    />

    <SecretFieldReveal
      v-else-if="isSecretField"
      :contactId="contactId"
      :field="field"
    />

    <ViewImageField
      v-else-if="isImageField"
      :value="fieldValue"
      :title="fieldSchema?.label || field"
      @click.native.stop
    />

    <div v-else-if="isUserListField" class="users-list-cell">
      <user-info-circle
        v-for="userId in fieldValue"
        :key="userId"
        :userId="userId"
      />
    </div>

    <div class="text-ellipsis" v-else>
      {{ fieldValue }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactsTableCell',
  components: {
    SecretFieldReveal: () =>
      import('@/components/formFields/secretField/SecretFieldReveal.vue'),
    ViewListFieldValue: () =>
      import(
        '@/views/contacts/components/specialContactFields/ViewListFieldValue.vue'
      ),
    ViewImageField: () => import('@/views/forms/helpers/ViewImageField.vue'),
    UserInfoCircle: () => import('@/views/contacts/contact/UserInfoCircle'),
  },
  props: {
    contactId: String,
    field: String,
    fieldValue: {},
    fieldSchema: {
      type: Object,
      default: () => ({}),
    },
    contactName: String,
  },
  computed: {
    fieldType() {
      return this.fieldSchema?.type;
    },
    isListField() {
      return ['list', 'related_contacts'].includes(this.fieldType);
    },
    isSecretField() {
      return this.fieldType === 'secret' && this.fieldValue;
    },
    isImageField() {
      return this.fieldType === 'image' && this.fieldValue;
    },
    isUserListField() {
      return this.fieldType === 'user_list';
    },
  },
};
</script>

<style>
.users-list-cell {
  display: flex;
  min-width: 110px;
}
</style>
